import { ButtonCTA } from 'components/ui';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useGetReferralsQuery } from 'store/services/segmentsApi';
import { usePageTitle } from 'utils';

export default function Referrals() {
  usePageTitle('Referrals | Segments');

  const [copied, setCopied] = useState(false);

  const { data } = useGetReferralsQuery();

  const copyToClipboard = () => {
    setCopied(true);
    toast.success('Link copied to clipboard', {
      onClose: () => setCopied(false),
      autoClose: 3000,
    });
    navigator.clipboard.writeText(String(data?.referral_link));
  };
  return (
    <div className="max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
      <div>
        <p className="font-bold">Settings</p>
        <h1 className="font-bold text-segments-44px">Referrals</h1>
        <p className="mt-4 text-base">
          Love Segments? We love you too! Help us spread the word, and keep
          track of who signs up.
        </p>
      </div>
      <div className="flex space-x-44 mt-14">
        <p className="whitespace-nowrap">Your referral link</p>
        <div className="space-y-7">
          <p className="font-bold">{data?.referral_link}</p>
          <div className="w-48">
            <ButtonCTA
              variant={copied ? 'main' : 'secondary'}
              type="button"
              onClick={copyToClipboard}
            >
              {copied ? 'Copied' : 'Copy link'}
            </ButtonCTA>
          </div>
        </div>
      </div>

      <div>
        <h3 className="mt-12 text-2xl leading-7">Your referrals</h3>
        <div className="px-10 py-8 mt-6 bg-white border shadow-md rounded-2xl">
          <table className="w-full">
            <thead className="text-segments-13px">
              <tr className="border-b border-black">
                <th className="pb-4 text-left w-60">Name</th>
                <th className="pb-4 text-left">Email</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {data?.referral_list?.map((item) => (
                <ReferralIndividualLine
                  name={item.name}
                  email={item.email}
                  key={item.email}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

/**
 *
 * @param {{name:string, email:string}} param0
 * @returns
 */
function ReferralIndividualLine({ name, email }) {
  return (
    <tr>
      <td className="py-2 font-bold ">{name}</td>
      <td>{email}</td>
    </tr>
  );
}
